import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  MudCalculationRequestDto,
  MudCalculationResultDto,
  MudFormulationDto,
  SaveMudFormulationDto,
} from '@models/mud-formulation-dto.interface';

@Injectable({ providedIn: 'root' })
export class MudFormulationService {
  private readonly api = inject(ApiService);

  calculate(dto: MudCalculationRequestDto): Observable<MudCalculationResultDto> {
    return this.api.post('mud-formulations/calculate', dto as unknown as object);
  }

  getByJobRequest(jobRequestId: number): Observable<MudFormulationDto> {
    return this.api.get(`mud-formulations/job-requests/${jobRequestId}`);
  }

  save(jobRequestId: number, dto: SaveMudFormulationDto): Observable<MudFormulationDto> {
    return this.api.put(`mud-formulations/job-requests/${jobRequestId}`, dto as unknown as object);
  }
}
